import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GraduatesSelect, getGraduates } from 'redux-api/slices/graduatesSlice';
import { REQUEST_STATUSES } from 'common/constants';
import cardShape from 'assets/icons/home/hmCardShape.svg';
// Стрелка красится цветом текста — желтеет вместе с подписью при наведении.
import { ReactComponent as GoArrow } from 'assets/icons/home/hmGoArrow.svg';
import classes from './HomeProjects.module.scss';
import HomeSlider from './HomeSlider';


// subtitle и action — для страницы Geeks Pro, где под заголовком есть текст и кнопка.
const HomeProjects = ({ title, subtitle, action }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { graduates, graduatesStatus } = useSelector(GraduatesSelect);

  useEffect(() => {
    dispatch(getGraduates());
    return () => null;
  }, [ dispatch ]);

  if (graduatesStatus !== REQUEST_STATUSES.SUCCEEDED || !graduates?.length) return null;

  return (
    <section className={classes.projects}>
      <div className={classes.container}>
        <HomeSlider
          title={title ?? t('GraduateProjects')}
          subtitle={subtitle}
          action={action}
          trackClass={classes.track} slideClass={classes.slide}>
          {graduates.map((item, i) => (
            <article
              className={classes.card}
              key={item?.url ?? i}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 100}
            >
              {/* Карточка с вырезом сверху — фигура из макета. */}
              <img className={classes.shape} src={cardShape} alt="" />

              <div className={classes.body}>
                <div className={classes.head}>
                  <h3 className={classes.name}>{item?.thesis}</h3>
                  <a
                    className={classes.go}
                    href={item?.url}
                    target="_blank"
                    rel="nofollow noreferrer"
                  >
                    {t('Go')}
                    <GoArrow aria-hidden />
                  </a>
                </div>
                <p className={classes.desc}>{item?.title}</p>
                <div className={classes.imageBox}>
                  <img src={item?.image} alt={item?.image_alt || item?.thesis} loading="lazy" />
                </div>
              </div>
            </article>
          ))}
        </HomeSlider>
      </div>
    </section>
  );
};

export default HomeProjects;
